<template>
  <div class="component">
    <div class="container">
      <div class="row align-items-end">
        <div class="col-lg-8 col-xl-9 mb-4 mb-lg-0">
          <h4>{{ acf.headline }}</h4>
          <p>{{ acf.content }}</p>
        </div>
        <div class="col-lg-4 col-xl-3">
          <a
            v-bind:href="acf.href"
            class="btn cta-plain text-white icon right-arrow float-lg-right"
            >{{ acf.cta }}</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "component-b7965f79",
  props: ["acf"],
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component {
  a {
    transition: all 0.5s;

    &:hover,
    &:focus {
      opacity: 0.5;
    }
  }
}
</style>